export function convertArrayToObject(data, key) {
  if (!key || !data.length || !data[0][key]) return {};
  return data.reduce((result, item) => ({ ...result, [item[key]]: { ...item } }), {});
}
